import { render, staticRenderFns } from "./BadgeCount.vue?vue&type=template&id=4435a425&scoped=true"
import script from "./BadgeCount.vue?vue&type=script&lang=js"
export * from "./BadgeCount.vue?vue&type=script&lang=js"
import style0 from "./BadgeCount.vue?vue&type=style&index=0&id=4435a425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4435a425",
  null
  
)

export default component.exports